import { useMemo, useState } from "react";
import { news } from "@/mocks/news";
import type { ArticleItem, NewsItem } from "@/mocks/types";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import LatestFeed from "./components/LatestFeed";
import HotRank from "./components/HotRank";
import FeatureArchives from "./components/FeatureArchives";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import ArticleModal from "./components/ArticleModal";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [selected, setSelected] = useState<ArticleItem | null>(null);

  const relatedNews = useMemo(() => {
    if (!selected || !("channel" in selected)) {
      return news.slice(0, 3);
    }
    const others = news.filter((n) => n.id !== selected.id);
    const same = others.filter((n) => n.channel === selected.channel);
    const rest = others.filter((n) => n.channel !== selected.channel);
    return [...same, ...rest].slice(0, 3);
  }, [selected]);

  const openNews = (item: NewsItem) => setSelected(item);
  const openFeature = (item: ArticleItem) => setSelected(item);

  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Navbar news={news} onRead={openNews} />
      <main>
        <Hero />
        <Ticker />
        <LatestFeed news={news} onRead={openNews} />
        <HotRank news={news} onRead={openNews} />
        <FeatureArchives onRead={openFeature} />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
      <ArticleModal
        item={selected}
        onClose={() => setSelected(null)}
        related={relatedNews}
        onOpenRelated={openNews}
      />
    </div>
  );
}